<template>
  <v-card :color="'rgb(250, 250, 250)'" class="elevation-0">
    <v-toolbar dense :color="colorBarraFormulario" dark flat>
      <v-toolbar-title v-bind:style="{ color: colorFondoDialog }">
        <span v-bind:style="{ color: 'white' }">Producto</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-chip class="mr-2 px-10" label :color="colorAccent1" text-color="white" link @click="_guardarProducto(false)">
        <span v-if="loading" v-bind:style="{ color: 'white' }">Guardando...</span>
        <span v-else v-bind:style="{ color: 'white' }">Guardar</span>
      </v-chip>
      <v-chip class="mr-2 px-10" label :color="colorAccent1" text-color="white" link @click="_guardarProducto(true)">
        <span v-if="loading" v-bind:style="{ color: 'white' }">Guardando...</span>
        <span v-else v-bind:style="{ color: 'white' }">Guardar y Cerrar</span>
      </v-chip>
      <v-icon size="30" :color="'white'" @click="_cerrarVentana">mdi-close-circle</v-icon>
    </v-toolbar>
    <v-card-text>
      <v-row class="mt-6" dense>
        <v-col cols="12" md="6">
          <v-row dense class="mx-4">
            <v-col cols="8" md="4">
              <v-text-field v-model="modelProducto.codigo" outlined label="Codigo" dense :dark="dark"
                autocomplete="off"></v-text-field>
            </v-col>
            <v-col cols="16" md="8">
              <v-text-field v-model="modelProducto.nombre" outlined label="Nombre" dense :dark="dark"
                autocomplete="off"></v-text-field>
            </v-col>
          </v-row>

          <v-row dense class="mx-4">
            <v-col cols="12">
              <v-textarea v-model="modelProducto.descripcion" outlined label="Descripcion" dense :dark="dark"
                autocomplete="off" rows="5" auto-grow></v-textarea>
            </v-col>
          </v-row>



          <v-row dense class="mx-4">
            <v-col cols="12" md="4">
              <v-text-field v-model="modelProducto.precio_unitario" outlined label="Precio unitario" dense :dark="dark"
                autocomplete="off" type="number" step="0.01"></v-text-field>
            </v-col>
          </v-row>

          <v-row dense class="mx-4">
            <v-col class="" cols="12" md="4">
              <v-text-field v-model="modelProducto.ubicacion" outlined label="Ubicacion" dense :dark="dark"
                autocomplete="off"></v-text-field>
            </v-col>
          </v-row>

          <v-divider class="mx-4 my-2"></v-divider>

          <v-row dense class="mt-6 mx-4">
            <v-col cols="12" md="4">
              <v-text-field v-model="modelProducto.stock_actual" outlined label="Stock actual" dense :dark="dark"
                autocomplete="off" type="number" step="0.01"></v-text-field>
            </v-col>
            <v-col class="ml-8" cols="12" md="4">
              <v-text-field v-model="modelProducto.stock_minimo" outlined label="Stock minimo" dense :dark="dark"
                autocomplete="off" type="number" step="0.01"></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
            </v-col>
          </v-row>

          <v-row dense class="mx-4">
            <v-col cols="12" md="4">
              <v-text-field v-model="modelProducto.stock_reservado" outlined label="Stock reservado" dense :dark="dark"
                disabled></v-text-field></v-col>


          </v-row>

          <v-row dense class="mx-4">
            <v-col cols="12" md="4">
              <v-text-field v-model="modelProducto.stock_disponible" outlined label="Stock disponible" dense
                :dark="dark" disabled></v-text-field>
            </v-col>
            <v-col cols="12" md="4">

            </v-col>
          </v-row>

          <v-divider class="mx-4 my-2"></v-divider>

          <v-row dense class="mt-2 mx-4">
            <v-col cols="12" md="12">
              <v-switch v-model="modelProducto.es_consumible_reserva" label="Descuento con reservas hechas"
                :dark="dark" dense></v-switch>
            </v-col>
          </v-row>

          <v-row dense class="mt-6 mx-4">
            <v-col cols="12" md="4">
              <v-select v-model="modelProducto.tipo_calculo" :items="tiposCalculo" item-text="text" item-value="value"
                outlined label="Tipo de calculo" dense :dark="dark" autocomplete="off"></v-select>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field v-model="modelProducto.cantidad_por_unidad" outlined label="Cantidad por unidad" dense
                :dark="dark" autocomplete="off" type="number" min="0" step="1"></v-text-field>
            </v-col>
          </v-row>

          <v-divider class="mx-4 my-2"></v-divider>

          <v-row dense class="mx-4">
            <v-col cols="12">
              <div class="d-flex align-center mb-2">
                <div class="subtitle-2">Caminos</div>
                <v-spacer></v-spacer>
                <v-btn style="color: white;" small class="mr-2" :color="colorAccent1" @click="_seleccionarTodosCaminos">
                  Marcar todos
                </v-btn>
                <v-btn style="color: white;" small :color="colorAccent3" @click="_deseleccionarTodosCaminos">
                  Desmarcar todos
                </v-btn>
              </div>
              <div v-if="usaTodosCaminos" class="subtitle-1 grey--text text--darken-1">
                Se usa en todos los caminos
              </div>
              <template v-else>
                <v-checkbox v-for="camino in caminos" :key="camino.id" v-model="selectedCaminos"
                  :value="camino.id" dense hide-details :dark="dark">
                  <template v-slot:label>
                    <span :style="{ fontWeight: camino.categoria_id > 10 ? 'bold' : 'normal' }">
                      {{ camino.titulo }}
                    </span>
                  </template>
                </v-checkbox>
              </template>
            </v-col>
          </v-row>

          
        </v-col>


        <v-col cols="12" md="6">
          <v-row dense class="mx-4">
            <v-col cols="12" md="12">
              <v-text-field v-model="modelProducto.proveedor_nombre" outlined label="Proveedor" dense :dark="dark"
                autocomplete="off"></v-text-field>
            </v-col>

          </v-row>

          <v-row dense class="mx-4">
            <v-col cols="12" md="6">
              <v-text-field v-model="modelProducto.proveedor_telefono" outlined label="Telefono proveedor" dense
                :dark="dark" autocomplete="off"></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field v-model="modelProducto.proveedor_web" outlined label="Web proveedor" dense :dark="dark"
                autocomplete="off"></v-text-field>
            </v-col>
          </v-row>

          <v-row dense class="mx-4">
            <v-col cols="12">
              <v-text-field v-model="modelProducto.proveedor_direccion" outlined label="Direccion proveedor" dense
                :dark="dark" autocomplete="off"></v-text-field>
            </v-col>
          </v-row>

          <v-divider class="mx-4 my-2 mb-8"></v-divider>

           <v-row dense class="mx-4">
            <v-col cols="12">
              <v-text-field v-model="modelProducto.proveedor_nif" outlined label="NIF proveedor" dense
                :dark="dark" autocomplete="off"></v-text-field>
            </v-col>
          </v-row>

           <v-row dense class="mx-4">
            <v-col cols="12">
              <v-text-field v-model="modelProducto.proveedor_nombrefiscal" outlined label="Nombre fiscal proveedor" dense
                :dark="dark" autocomplete="off"></v-text-field>
            </v-col>
          </v-row>

           <v-row dense class="mx-4">
            <v-col cols="12">
              <v-text-field v-model="modelProducto.proveedor_direccionfiscal" outlined label="Direccion fiscal proveedor" dense
                :dark="dark" autocomplete="off"></v-text-field>
            </v-col>
          </v-row>



          <v-divider class="mx-4 my-2 mb-8"></v-divider>

          <v-row dense class="mx-4">
            <v-col cols="12">
              <v-text-field v-model="modelProducto.proveedor_email" outlined label="Email proveedor" dense :dark="dark"
                autocomplete="off"></v-text-field>
            </v-col>
          </v-row>


          <v-row dense class="mx-4">
            <v-col cols="12">
              <v-text-field v-model="modelProducto.asunto_mensaje" outlined label="Asunto mensaje" dense :dark="dark"
                autocomplete="off"></v-text-field>
            </v-col>
          </v-row>

          <v-row dense class="mx-4">
            <v-col cols="12">
              <v-textarea v-model="modelProducto.texto_mensaje" outlined label="Texto mensaje" dense :dark="dark"
                autocomplete="off" rows="8" auto-grow></v-textarea>
            </v-col>
          </v-row>

          <v-row dense class="mt-2 mx-4 ml-8 ">
            <v-col cols="12" md="12">
              <v-switch v-model="modelProducto.aviso_automatico_externo" label="Aviso automatico externo"
                :dark="dark" dense></v-switch>
            </v-col>
          </v-row>

         

          
        </v-col>
      </v-row>

      <v-row class="mx-4 mb-2">

      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "ProductoFormulario",
  data: () => ({
    loading: false,
    tiposCalculo: [
      { text: "Por Peregrino", value: "POR_PEREGRINO" },
      { text: "Por Reserva", value: "POR_RESERVA" },
      { text: "Por Habitacion", value: "POR_HABITACION" },
    ],
    selectedCaminos: [],
    caminosInicializados: false,
  }),

  props: {
    modelProducto: {
      type: Object,
      required: true,
    },
    accion: {
      type: String,
      required: true,
    },
  },

  computed: {
    ...mapState([
      "drawer",
      "dark",
      "colorAccent1",
      "colorAccent2",
      "colorAccent3",
      "colorBarraFormulario",
      "colorFondoDialog",
    ]),
    ...mapState("auth", [
      "user",
      "date",
      "access_token",
      "error",
      "errorMessage",
    ]),
    ...mapState("caminos", ["caminos"]),

    usaTodosCaminos() {
      if (!this.caminos || !this.caminos.length) {
        return false;
      }
      return Array.isArray(this.selectedCaminos) && this.selectedCaminos.length === this.caminos.length;
    },
  },

  watch: {
    modelProducto: {
      handler() {
        this.caminosInicializados = false;
        this._initSelectedCaminos();
      },
      immediate: true,
    },
    caminos() {
      this.caminosInicializados = false;
      this._initSelectedCaminos();
    },
  },

  mounted() {
    this._cargarCaminos();
  },

  methods: {
    ...mapActions("inventario", ["updateProducto"]),
    ...mapActions("caminos", ["getCaminos"]),

    _cerrarVentana() {
      this.$emit("cerrarFormularioProducto");
    },

    async _cargarCaminos() {
      await this.getCaminos([this.access_token, false]);
      this._initSelectedCaminos();
    },

    _initSelectedCaminos() {
      if (this.caminosInicializados || !this.caminos) {
        return;
      }
      if (!this.caminos.length) {
        this.caminosInicializados = true;
        return;
      }
      const raw = this.modelProducto ? this.modelProducto.caminos : null;
      if (!raw) {
        this.selectedCaminos = this.caminos.map((c) => c.id);
        this.caminosInicializados = true;
        return;
      }

      try {
        const parsed = typeof raw === "string" ? JSON.parse(raw) : raw;
        if (Array.isArray(parsed) && parsed.length) {
          this.selectedCaminos = parsed
            .map((c) => (c && c.id != null ? Number(c.id) : null))
            .filter((id) => id != null);
        } else {
          this.selectedCaminos = this.caminos.map((c) => c.id);
        }
      } catch (e) {
        this.selectedCaminos = this.caminos.map((c) => c.id);
      }
      this.caminosInicializados = true;
    },

    _prepararCaminosParaGuardar() {
      if (!this.caminos || !this.caminos.length) {
        return;
      }
      const total = this.caminos.length;
      const seleccionados = this.selectedCaminos || [];
      const seleccionadosNumericos = seleccionados.map((id) => Number(id));

      if (!seleccionadosNumericos.length || seleccionadosNumericos.length === total) {
        this.modelProducto.caminos = null;
        return;
      }

      const caminosSeleccionados = this.caminos
        .filter((c) => seleccionadosNumericos.includes(Number(c.id)))
        .map((c) => ({ id: c.id, titulo: c.titulo }));
      this.modelProducto.caminos = JSON.stringify(caminosSeleccionados);
    },

    _seleccionarTodosCaminos() {
      if (this.caminos && this.caminos.length) {
        this.selectedCaminos = this.caminos.map((c) => c.id);
      }
    },

    _deseleccionarTodosCaminos() {
      this.selectedCaminos = [];
    },

    async _guardarProducto(cerrar) {
      this.loading = true;
      this._prepararCaminosParaGuardar();
      if (this.accion == "editar") {
        await this.updateProducto([this.access_token, this.modelProducto]);
      }
      this.loading = false;
      if (cerrar) {
        this._cerrarVentana();
      }
    },
  },
};
</script>
